import MDButton from 'components/MDButton';
import React, { useState } from 'react';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import { useAgencyInfo } from 'context/agency';

const CreateModal = ({ handleRefresh }) => {
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [jsonFile, setJsonFile] = useState(null);

  const handleModal = () => setOpenAddProduct(true);
  const closeAddProduct = () => setOpenAddProduct(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setJsonFile(file);
  };

  const handleUploadJSON = async () => {
    if (!jsonFile) {
      alert("Please select a JSON file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const jsonData = JSON.parse(event.target.result);
        if (!jsonData.name || !Array.isArray(jsonData.name)) {
          alert("Invalid JSON format. Expected an array of names.");
          return;
        }

        setProcessing(true);
        const payload = jsonData.name.map((category) => ({ name: category }));
        const { response } = await AppService.checklistcategory.create({ payload });

        if (response) {
          alert("Checklist categories uploaded successfully!");
          handleRefresh();
        } else {
          alert("Failed to upload JSON data.");
        }
      } catch (error) {
        alert("Error processing JSON file.");
      } finally {
        setProcessing(false);
      }
    };

    reader.readAsText(jsonFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    const payload = { name: e.target.name.value };
    const { response } = await AppService.servicecategory.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Checklist Category
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="primary" type="button" sx={{ mt: 2, mb: 1 }} onClick={closeAddProduct}>
                Close
              </MDButton>
              <MDButton variant="gradient" color="info" type="submit" sx={{ mt: 2, mb: 1, ml: 1 }} disabled={processing}>
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default CreateModal;
